module.exports = __webpack_public_path__ + "assets/images/advancedRouteEditing-c0cd004996232f27459ca90db723509f.webm";